// These are used by backend security requests.
// It
export enum AbortActionEnum {
  THROW = 'THROW',
  RELOAD = 'RELOAD',
}
